import { useSelector } from 'react-redux';
import { selectors } from 'state';

const useUser = () => useSelector(selectors.users.getCurrentUser);

export default useUser;
